<section class="app2 services" id="services">
  <div class="container">
    <div class="row">
      @defer(on idle){
      <div class="col-md-10 offset-md-1">
        <div class="title title2">
          <img [src]="serviceImage" alt="" class="img-fluid title-img">
          <div class="sub-title">
            <h2 class="title-text text-center">{{mainText}}</h2>
          </div>
        </div>
        <p class=" text-center mb-4 main-text-services">
          <span>{{title}}</span>
        </p>
      </div>
      @for (service of serviceContainer; track service.id; let index = $index) {
      <div class="col-lg-3 col-md-6 service-container">
        <div class="service text-center">
          <div class="service-feature">
            <div class="circle-container d-flex align-items-center justify-content-center mb-4">
              <span class="circle text-center">{{index + 1}}</span>
            </div>
            <p class="feature-text text-center">{{service.title}}</p>
            <p class="text-center">{{service.description}}</p>
          </div>
        </div>
      </div>
      }
      }@placeholder {
      @switch (screenSize$ | async) {
      @case ('xsmall') {
      <div class="col-md-10 offset-md-1">
        <div class="title title2">
          <img [src]="serviceImage" alt="" class="img-fluid title-img">
          <div class="sub-title">
            <ngx-skeleton-loader />
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 service-container">
        <ngx-skeleton-loader [theme]="{height:'250px'}" />
      </div>
      }
      @case ('small') {
      <div class="col-md-10 offset-md-1">
        <div class="title title2">
          <img [src]="serviceImage" alt="" class="img-fluid title-img">
          <div class="sub-title">
            <ngx-skeleton-loader />
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 service-container">
        <ngx-skeleton-loader [theme]="{height:'250px'}" />
      </div>
      <div class="col-lg-3 col-md-6 service-container">
        <ngx-skeleton-loader [theme]="{height:'250px'}" />
      </div>
      }
      @default {
      <div class="col-md-10 offset-md-1">
        <div class="title title2">
          <img [src]="serviceImage" alt="" class="img-fluid title-img">
          <div class="sub-title">
            <ngx-skeleton-loader />
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 service-container">
        <ngx-skeleton-loader [theme]="{height:'250px'}" />
      </div>
      <div class="col-lg-3 col-md-6 service-container">
        <ngx-skeleton-loader [theme]="{height:'250px'}" />
      </div>
      <div class="col-lg-3 col-md-6 service-container">
        <ngx-skeleton-loader [theme]="{height:'250px'}" />
      </div>
      <div class="col-lg-3 col-md-6 service-container">
        <ngx-skeleton-loader [theme]="{height:'250px'}" />
      </div>
      }
      }
      }
    </div>
  </div>
</section>
